import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { ApiBaseUrlContext } from '../App';

const TechnicianDropdown = ({ onSelectTechnician, value }) => {
  const [technicians, setTechnicians] = useState([]);
  const apiBaseUrl = useContext(ApiBaseUrlContext);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchTechnicians = async () => {
      try {
        const response = await axios.get(`${apiBaseUrl}/mnt/api/technicians`, {
          headers: {
            'Accept': 'application/json'
          }
        });
        // Filter technicians with 'external technician' or 'internal technician' rights
        const filteredTechnicians = response.data.filter(tech => 
          tech.user_rights === 'external technician' || tech.user_rights === 'internal technician'
        );
        setTechnicians(filteredTechnicians);
      } catch (error) {
        console.error(t('TechnicianDropdown.ErrorFetchingTechnicians'), error);
      }
    };

    fetchTechnicians();
  }, [apiBaseUrl, t]);

  const handleSelect = (event) => {
    const selectedValue = event.target.value;

    if (selectedValue === '') {
      onSelectTechnician({ name: '' }); // Clear the filter when "Any Technician" is selected
    } else {
      const selectedTechnician = technicians.find(tech => `${tech.userfirstname} ${tech.userlastname}` === selectedValue);
      if (selectedTechnician) {
        onSelectTechnician({
          name: selectedValue,
          hourly_rate: selectedTechnician.rateperhour,
          external: selectedTechnician.userexternal === 1
        });
      }
    }
  };

  return (
    <select className="form-select" onChange={handleSelect} value={value}>
      <option value="">{t('TechnicianDropdown.AnyTechnician')}</option> {/* Option to not filter by technician */}
      {technicians.map(technician => (
        <option key={technician.userid} value={`${technician.userfirstname} ${technician.userlastname}`}>
          {technician.userfirstname} {technician.userlastname}
        </option>
      ))}
    </select>
  );
};

export default TechnicianDropdown;
